(() => {
  const selector = '[data-shipping-payment]';

  function init(section) {
    if (!section || section.dataset.shippingPaymentReady === 'true') return;
    section.dataset.shippingPaymentReady = 'true';

    section.querySelectorAll('[data-shipping-payment-faq]').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        section.querySelectorAll('[data-shipping-payment-faq][open]').forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  }

  function initAll(root = document) {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();